import { topSidePartOfWeb } from './parts/sideParts'

export const type6Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // ウェブ本体
  ctx.beginPath()
  ctx.moveTo(300, 376) //
  ctx.quadraticCurveTo(339, 334, 373, 252) // 右下
  ctx.quadraticCurveTo(384, 159, 359, 92) // 右上
  ctx.quadraticCurveTo(269, 153, 210, 260) // 左上
  ctx.quadraticCurveTo(300, 376, 300, 376) // 左下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // ウェブ先端
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(247, 283) // 左上
  ctx.quadraticCurveTo(255, 250, 283, 207) //
  ctx.quadraticCurveTo(298, 194, 308, 214) //
  ctx.quadraticCurveTo(322, 253, 322, 253) //
  ctx.quadraticCurveTo(340, 238, 362, 187) //
  // 右上
  ctx.moveTo(335, 120)
  ctx.quadraticCurveTo(325, 161, 325, 196) //
  ctx.quadraticCurveTo(342, 139, 358, 131) //
  // 左下
  ctx.moveTo(268, 313)
  ctx.quadraticCurveTo(295, 245, 295, 245) //
  ctx.quadraticCurveTo(303, 238, 307, 253) //
  ctx.quadraticCurveTo(313, 289, 313, 289) //
  ctx.quadraticCurveTo(321, 305, 343, 276) //
  ctx.quadraticCurveTo(371, 243, 375, 241) //
  ctx.moveTo(291, 356)
  ctx.quadraticCurveTo(295, 303, 295, 303) //
  ctx.quadraticCurveTo(304, 320, 313, 350) //
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
}
